const RelatorioConferenciasModuleRelatorios = () =>
  import(/* webpackChunkName: "group-pabx-relatorio" */ '../_views/RelatorioConferenciasModuleRelatorios')

import { permissoesRelatoriosConferencias } from '../../../utils/permissionsRelatoriosPabx'

export default [
  {
    path: 'conferencias',
    component: RelatorioConferenciasModuleRelatorios,
    meta: { requiresAuth: true, permissions: [...permissoesRelatoriosConferencias] },
    name: 'relatorios_pabx_conferencias',
  },
]
